function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { createContext, useReducer, useContext, useMemo } from 'react';
var initialState = [];
var AccordionContext = createContext(undefined);

// custom Hook to just check if the Consumer is a child of a Provider
export function useAccordionContext(component) {
  var context = useContext(AccordionContext);
  if (typeof context === 'undefined') {
    throw new Error("".concat(component, " must be used within an Accordion component."));
  }
  return context;
}
function reducer(state, action) {
  switch (action.type) {
    case 'on:radio':
      return [action.payload];
    case 'off:radio':
      return state.includes(action.payload) ? [] : state;
    case 'on:checkbox':
      return state.concat(action.payload);
    case 'off:checkbox':
      return state.filter(function (id) {
        return id !== action.payload;
      });
    default:
      return state;
  }
}
export default function Accordion(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'checkbox' : _ref$type,
    _ref$namespace = _ref.namespace,
    namespace = _ref$namespace === void 0 ? '' : _ref$namespace,
    children = _ref.children;
  var _useReducer = useReducer(reducer, initialState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    checked = _useReducer2[0],
    dispatch = _useReducer2[1];
  var context = useMemo(function () {
    return {
      checked: checked,
      namespace: namespace,
      dispatch: dispatch,
      type: type
    };
  }, [checked, namespace, type]);
  return /*#__PURE__*/React.createElement(AccordionContext.Provider, {
    value: context
  }, children);
}